import { render, staticRenderFns } from "./skin-analyser.vue?vue&type=template&id=05cbd7ca&scoped=true&"
import script from "./skin-analyser.vue?vue&type=script&lang=js&"
export * from "./skin-analyser.vue?vue&type=script&lang=js&"
import style0 from "./skin-analyser.vue?vue&type=style&index=0&id=05cbd7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cbd7ca",
  null
  
)

component.options.__file = "skin-analyser.vue"
export default component.exports